import React from "react";
import "./awards.css";
import { useTranslation } from "react-i18next";

const Awards = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="awards padding">
        <div className="container">
          <div className="heading">
            <h1>{t("awards_title")}</h1>
          </div>

          <div className="content grid4 mtop">
            {/* Box 1 */}
            <div className="box">
              <div className="icon">
                <span>
                  <i className="fa-solid fa-trophy"></i>
                </span>
              </div>
              <h1>{t("awards_exp_title")}</h1>
              <p>{t("awards_exp_desc")}</p>
            </div>

            {/* Box 2 */}
            <div className="box">
              <div className="icon">
                <span>
                  <i className="fa-solid fa-user"></i>
                </span>
              </div>
              <h1>{t("awards_customers_title")}</h1>
              <p>{t("awards_customers_desc")}</p>
            </div>

            {/* Box 3 */}
            <div className="box">
              <div className="icon">
                <span>
                  <i className="fa-solid fa-briefcase"></i>
                </span>
              </div>
              <h1>{t("awards_projects_title")}</h1>
              <p>{t("awards_projects_desc")}</p>
            </div>

            {/* Box 4 */}
            <div className="box">
              <div className="icon">
                <span>
                  <i className="fa-solid fa-heart"></i>
                </span>
              </div>
              <h1>{t("awards_reviews_title")}</h1>
              <p>{t("awards_reviews_desc")}</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Awards;
